import { ICardElementWithChildren } from "backend/model/model";

const typeToViewMap: Record<string, string | undefined> = {
  "Strategic Objective": "objective",
  Organization: "strategymap",
  KPI: "kpidetails",
  Initiative: "initiativedetails",
};

const typeToView = (typename: string) => {
  if (typeToViewMap[typename]) {
    return typeToViewMap[typename];
  }
  return "";
};

export default typeToView;
